"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Marker = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const markerClass = (0, nano_theme_1.rule)({
    pos: 'absolute',
    l: '2px',
    r: '2px',
});
const Marker = ({ position, color = 'currentColor', height: markerHeight = 2, onClick, children, className, style, ...rest }) => {
    const computedStyle = {
        top: `${Math.max(0, Math.min(1, position)) * 100}%`,
        height: markerHeight,
        pointerEvents: onClick ? 'auto' : 'none',
        background: children ? undefined : color,
        ...style,
    };
    if (typeof children === 'function') {
        return React.createElement(React.Fragment, null, children(computedStyle));
    }
    return (React.createElement("div", { ...rest, className: markerClass + (className ? ' ' + className : ''), style: computedStyle, onClick: onClick, onKeyDown: onClick
            ? (e) => {
                if (e.key === 'Enter' || e.key === ' ')
                    onClick();
            }
            : undefined, role: onClick ? 'button' : undefined, tabIndex: onClick ? 0 : undefined }));
};
exports.Marker = Marker;
